<template>
  <div class="hotelRoom">
    <div class="hotelRoomPhotoCover">
      <div class="hotelRoomPhoto" aria-label="客室の写真">
        <img
          v-if="displaySingleImage"
          :src="viewImagePath"
          class="tourHotelSelectRoom_reserve-hotelImage"
          alt="room image"
          @error="imageLoadFailed = true"
        />
        <template v-else>
          <tk-image-swiper
            :image-list="imageList"
            class="swiper-container"
            :swiper-options="swiperOption"
          />
          <div :class="['swiper-pagination', `swiper-pagination-${id}`]"></div>
        </template>
      </div>
    </div>

    <room-type-info
      :no-smoking="noSmoking"
      :room-type-name="name"
      :introduction="introduction"
      :area="area"
      :bed-type="bedType"
      :bed-type-info="bedTypeInfo"
      :left-room-number="leftRoomNumber"
      :max-guest-number="maxGuestNumber"
      :wifi="wifi"
      :bath-room="bathRoom"
      :amenity="amenity"
      :accommodation-children="accommodationChildren"
      :barrier-free="barrierFree"
      :note="note"
      :image-list="imageList"
    />
  </div>
</template>

<script>
import TkImageSwiper from '../../atoms/TkImageSwiper/TkImageSwiper'
import RoomTypeInfo from './RoomTypeInfo.vue'

export default {
  name: 'TkRoomTypeCard',
  components: {
    TkImageSwiper,
    RoomTypeInfo,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    maxGuestNumber: {
      type: Number,
      default: 0,
    },
    area: {
      type: Number,
      default: 0,
    },
    leftRoomNumber: {
      type: Number,
      default: 0,
    },
    bedType: {
      type: String,
      required: true,
    },
    bedTypeInfo: {
      type: String,
      default: '',
    },
    noSmoking: {
      type: Boolean,
      default: false,
    },
    imageList: {
      type: Array,
      default() {
        return []
      },
    },
    introduction: {
      type: String,
      default: '',
    },
    wifi: {
      type: String,
      default: '',
    },
    bathRoom: {
      type: String,
      default: '',
    },
    amenity: {
      type: String,
      default: '',
    },
    accommodationChildren: {
      type: String,
      default: '',
    },
    barrierFree: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
  },
  data() {
    const id = this._uid
    return {
      id,
      imageLoadFailed: false,
      swiperOption: {
        speed: 1000,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: `.swiper-pagination-${id}`,
          type: 'fraction',
        },
      },
    }
  },
  computed: {
    viewImagePath() {
      let viewImagePath = ''
      if (this.imageList && this.imageList.length > 0) {
        viewImagePath = this.imageList[0]
      }
      if (!viewImagePath || this.imageLoadFailed) {
        viewImagePath = require('@ota-frontend/shared-assets/images/common/noimage.jpg')
      }
      return viewImagePath
    },
    displaySingleImage() {
      return this.imageList && this.imageList.length <= 1
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkRoomTypeCard.scss';
.hotelRoomPhoto .swiper-button-prev,
.hotelRoomPhoto .swiper-button-next {
  display: none;
}
</style>
